import * as React from 'react';
import { EQuickLookType, ICardProps } from './types';
import { CARD_ACTIONS_PORTAL, CARD_CLASS, CARD_CONTROL_CLASS, CARDS_SCROLL_CLASS } from '../../../../constants';
import './Card.scss';
import { getParentsClasses } from '../../../../../../helpers/getParentsClasses';
import { GOOGLE_SPACING } from '../../../../../../../../const';
import { getWeeks } from './helpers/getWeeks';
import { ECardAgingIndicatorType } from '../../../../../../../../types/rest/ICardAging';
import { CARD_BLINK_ANIMATION_TIME, CARD_TITLE_EDIT_HINT } from './constants';
import { AnalyzeRender } from 'app/view/react_components/helpers/memoizeHelper';
import { NAVIGATION_PANEL_CONTAINER_CLASS } from 'app/view/react_components/main/navigationPanel/constants';
import { root } from '../../../../../../../../store/constants';
import { CardRender } from './cardRender';
import { EHintKey, HintHOC } from '../../../../../../hints';
import { v4 as uuidv4 } from 'uuid';

// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`Card`) : null;

export function Card (props: ICardProps) {
    const {
        backgroundColor,
        boardId,
        boardRoles,
        cardAgingIndicator,
        cardNumber,
        collaborators,
        dragHandleProps,
        editedNameCardId,
        estimate,
        height,
        hideActions,
        id,
        isQuickLookCollapse,
        isCardAgingOpacity,
        isCovered,
        isDragging,
        isFakeCovered,
        isFullLoaded,
        isHighlight,
        isMultipleDragging,
        isMultiselect,
        isNotFilled,
        isReadonly,
        isRecentlyWatched,
        isRecurring,
        isRelatedCardEdit,
        isRelatedPanel,
        isSelected,
        isShowAgeing,
        isShowAssignees,
        isShowDueDate,
        isShowEstimate,
        isShowPriority,
        isShowStartDate,
        isTemplate,
        listId,
        openedQuickLook,
        timeSinceLastActivity,
        timeSinceMovedToList,
        viewListId,
        setHeight,
        onAnimationEnd,
        onCardClick,
        onDidMount,
        onLoadData,
        onQuickLookChange,
        onHideHint,
    } = props;

    const [_props, _setProps] = React.useState(props);

    const [isColorTagsOpened, setColorTagsOpened] = React.useState(null);
    const [isOpenColorTagsDropdown, setOpenColorTagsDropdown] = React.useState(null);

    // const propsString = JSON.stringify(props);
    // const stateString = JSON.stringify(_props);
    // let stringEqual = '';
    // for (let i=0; i<propsString.length; i++) {
    //     if (propsString[i] === stateString[i]) {
    //         stringEqual += propsString[i];
    //     } else {
    //         console.log('Card: ', name);
    //         console.log('stringEqual: ', stringEqual.slice(-20), '___', propsString.slice(i, i + 20));
    //         break;
    //     }
    // }

    if (analyzeRender) analyzeRender.call(`${id} ${cardNumber}`, arguments[0]);

    const cardRef = React.useRef(null);
    const modulesRef = React.useRef(null);
    const cloneRef = React.useRef(null);

    const debounceHeight = React.useRef(null);
    const data = React.useRef({ height });
    data.current = { height };

    const cardClasses = [CARD_CLASS, CARD_CLASS + id];
    const [classUnique] = React.useState(CARD_CLASS + '--' + uuidv4());

    const [isTitleEditing, setTitleEditing] = React.useState(null);
    const [editingName, setEditingName] = React.useState(null);

    let [cardStyle, _setCardStyle] = React.useState<React.CSSProperties>({
        backgroundColor,
    });
    const setCardStyle = (value: React.CSSProperties) => {
        cardStyle = {
            ...cardStyle,
            ...value,
        };
        _setCardStyle(cardStyle);
    }

    if (backgroundColor) {
        const colorCode = backgroundColor.slice(1).toUpperCase();
        cardClasses.push(`${CARD_CLASS}--colored`);
        cardClasses.push(`${CARD_CLASS}--bgcolor-${colorCode}`);
    }
    if (isCovered) {
        cardClasses.push(`${CARD_CLASS}--loading`);
    }
    if (isFakeCovered) {
        cardClasses.push(`${CARD_CLASS}--fake-loading`);
    }
    if (isRecentlyWatched) {
        cardClasses.push(`${CARD_CLASS}--recently-watched`);
    }
    if (isSelected) {
        cardClasses.push(`${CARD_CLASS}--selected`);
    }
    const isCollaboratorsSmall = !isShowDueDate &&
        !isShowStartDate &&
        !isShowPriority &&
        isShowAssignees &&
        (!isShowEstimate || !estimate);
    if (collaborators.length) {
        cardClasses.push(`${CARD_CLASS}--w-collaborators`);
        if (isCollaboratorsSmall) {
            cardClasses.push(`${CARD_CLASS}--w-collaborators-small`);
        }
    }

    const [isShowHint, setShowHint] = React.useState(null);
    React.useEffect(() => {
        if (!isShowHint) return;

        const onScroll = () => {
            const list = document.querySelector(`.${CARDS_SCROLL_CLASS}--${listId}`) as HTMLElement;
            if (!list) return;
            list.removeEventListener('scroll', onScroll);
            setShowHint(false);
            onHideHint();
        };

        const list = document.querySelector(`.${CARDS_SCROLL_CLASS}--${listId}`) as HTMLElement;
        if (!list) return;
        list.addEventListener('scroll', onScroll);

        return () => {
            const list = document.querySelector(`.${CARDS_SCROLL_CLASS}--${listId}`) as HTMLElement;
            if (!list) return;
            list.removeEventListener('scroll', onScroll);
            setShowHint(false);
        }
    }, [isShowHint]);

    /**
     * boder
     */
    React.useEffect(() => {
        let style = {
            backgroundColor,
            backgroundImage: '',
            borderColor: '',
            height: 'auto'
        }
        if (collaborators.length) {
            if (collaborators.length === 1) {
                if (!isSelected) {
                    style.borderColor = collaborators[0].color;
                }
            } else if (collaborators.length > 1) {
                const colorsArray: string[] = [];
                collaborators.forEach(collaborator => {
                    colorsArray.push(collaborator.color)
                })
                const gradient = `linear-gradient(to right, ${colorsArray.join(', ')})`;
                style.backgroundImage = `radial-gradient(white, white), ${gradient}`;
            }
        }
        setCardStyle(style);
    }, [backgroundColor, collaborators, isSelected]);

    if (isSelected && isMultiselect) {
        cardClasses.push(`${CARD_CLASS}--multi-selected`)
    }
    if (isMultipleDragging) {
        cardClasses.push(`${CARD_CLASS}--multiple-dragging`)
    }
    if (isNotFilled) {
        cardClasses.push(`${CARD_CLASS}--error`);
    }

    /**
     * aging opacity
     */
    let weeks = 0;
    if (isShowAgeing && isCardAgingOpacity) {
        let cardAgingOpacityClass = CARD_CLASS + '--aging';
        const time = Date.now() - (cardAgingIndicator === ECardAgingIndicatorType.BY_LIST
            ? timeSinceMovedToList
            : timeSinceLastActivity);
        weeks = getWeeks(time);
        if (weeks === 0) {
            cardAgingOpacityClass += '-0-week';
        } else if (weeks === 1) {
            cardAgingOpacityClass += '-1-week';
        } else if (weeks === 2) {
            cardAgingOpacityClass += '-2-week';
        } else if (weeks === 3) {
            cardAgingOpacityClass += '-3-week';
        } else {
            cardAgingOpacityClass += '-4-week';
        }
        cardClasses.push(cardAgingOpacityClass);
    }

    /**
     * blink collaborator
     */
    const [isCardVisible, setCardVisible] = React.useState(null);
    if (isHighlight) {
        let aging = weeks > 0 ? 'aging-' : '';
        let delay = isCardVisible ? '-delay' : '';
        cardClasses.push(`${CARD_CLASS}--${aging}blink${delay}`);
    }

    const checkCardVisibility = () => {
        let isCardVisibility: boolean = null;
        const card = cardRef.current;
        if (!card) return isCardVisibility;

        const nav = document.querySelector('.' + NAVIGATION_PANEL_CONTAINER_CLASS) as HTMLElement;
        const navWidth = nav ? nav.offsetWidth : 0;
        const rect = card.getBoundingClientRect();
        isCardVisibility = rect.right > navWidth &&
            rect.left < root._innerWidth &&
            rect.right < root._innerWidth &&
            rect.left > navWidth;
        return isCardVisibility
    }

    React.useEffect(() => {
        if (isHighlight) {
            const isCardVisible = checkCardVisibility();
            setCardVisible(isCardVisible);

            setTimeout(() => { // wait until animation is finished
                onAnimationEnd();
            }, CARD_BLINK_ANIMATION_TIME);
        }
    }, [isHighlight, isCardAgingOpacity]);

    /**
     * QuickLook
     */
    const [isLoadingQuickLook, setLoadingQuickLook] = React.useState(openedQuickLook ? false : null);
    const onQuickLook = (
        newQuickLook: EQuickLookType
    ) => {
        if (openedQuickLook === newQuickLook) newQuickLook = null;

        onQuickLookChange(newQuickLook);
        setLoadingQuickLook(null);

        if (newQuickLook) {
            if (!isFullLoaded && !isLoadingQuickLook) {
                setLoadingQuickLook(true);
                onLoadData()
                    .then(() => {
                        setLoadingQuickLook(false);
                    })
                    .catch((e) => { // карта не загрузилась
                        if (openedQuickLook === newQuickLook) { // тот же QuickLook ещё открыт
                            onQuickLookChange(null); // закрыть его
                        }
                    });
            } else {
              setLoadingQuickLook(false);
            }
        }
    };

    function onClick (e: React.MouseEvent) {
        const { tagName } = e.target as HTMLElement;
        if (tagName && tagName.toLowerCase() === 'a') return; // ссылка в pinnedChecklist
        const targetClasses = getParentsClasses(
            e.target as HTMLElement, [
                CARD_CONTROL_CLASS,
                CARD_CLASS
            ]);
        if (targetClasses.includes(CARD_CONTROL_CLASS)) {
            return;
        }
        modulesRef.current.focus(); // панельке нужно знать, куда вернуть фокус
        onCardClick(e);
    }

    function onKeyDown (event: React.KeyboardEvent) {
        if (!event) return;
        if (event.key === 'Enter') {
            onClick(event as any);
        }
    }

    // KNB-4284 когда карта появляется через moveTo из другой вкладки браузера и высота карты дефолтная (90px),
    // то высота в DropdobleItem.tsx будет null и карточка не отрисуется
    const [isRendered, setRendered] = React.useState(null);

    function setCardHeightAndProps() {
        //console.log(openedQuickLook,isQuickLookCollapse);
        let debounce = 40;
        if (!data.current.height) {
            //_setCardHeightAndProps();
        } else if (openedQuickLook === EQuickLookType.DESCRIPTION && (isQuickLookCollapse === undefined || isQuickLookCollapse)) { //кроме дискрипшена, мы сразу меняем размер
            debounce = 200;
        } else {
            //_setCardHeightAndProps();
        }
        if (debounceHeight.current) clearTimeout(debounceHeight.current);
        debounceHeight.current = setTimeout(_setCardHeightAndProps, debounce);

    }

    function _setCardHeightAndProps() {
        //console.log('cloneRef.current', cloneRef.current);
        if (
            cloneRef.current &&
            cloneRef.current.offsetHeight
        ) {
            let margin= GOOGLE_SPACING * 1.25;
            if (collaborators.length && isCollaboratorsSmall) {
                margin -= GOOGLE_SPACING * 0.75;
            }
            let h = cloneRef.current.offsetHeight + margin;
            //console.log('setCardHeight',h);
            setRendered(true);
            if (setHeight) setHeight(h);
        }
        //console.log('props');
        setProps();
    };

    React.useEffect(() => {
        setCardHeightAndProps();
    }, [isCollaboratorsSmall, collaborators, editingName]);

    let setProps = () => {
        _setProps(props);
    }

    React.useEffect(() => {
        setProps();
    }, [ // эти свойства нужно применить сразу. Остальные сначала применяются на клоне для расчёта высоты
        backgroundColor,
        boardId,
        boardRoles,
        collaborators,
        dragHandleProps,
        height,
        hideActions,
        id,
        isCardAgingOpacity,
        isCovered,
        // isFakeCovered, // меняется при любом изменении
        isMultipleDragging,
        isNotFilled,
        isReadonly,
        isRecentlyWatched,
        isRecurring,
        isRelatedCardEdit,
        isRelatedPanel,
        isTemplate,
        listId,
        timeSinceLastActivity,
        timeSinceMovedToList,
        viewListId,
    ]);

    React.useEffect(() => {
        onDidMount();
    }, []);

    const className = cardClasses.join(' ');

    return <>
        {height || isDragging || isTemplate || isRendered ?
            <CardRender {...{
                className: `${className} ${classUnique}`,
                cardRef,
                editingName,
                modulesRef,
                isLoadingQuickLook,
                isTitleEditing,
                style: cardStyle,
                isColorTagsOpened,
                isOpenColorTagsDropdown,
                setColorTagsOpened,
                setOpenColorTagsDropdown,
                setCardHeightAndProps: ()=>{}, // высоту меняет клон
                setEditingName,
                setTitleEditing,
                onClick,
                onKeyDown,
                onQuickLook,
                ..._props,
            }}/>
            : <div className={CARD_CLASS + '--dummy'} />
        }
        <CardRender {...{
            className: className + ' clone',
            cardRef: cloneRef,
            editingName,
            isClone: true,
            isLoadingQuickLook,
            isColorTagsOpened,
            isOpenColorTagsDropdown,
            setColorTagsOpened,
            setOpenColorTagsDropdown,
            isTitleEditing,
            ...props,
            setCardHeightAndProps,
            setEditingName,
            setTitleEditing,
            setProps,
        }}/>
        {editedNameCardId === id &&
            <HintHOC
                key={EHintKey.KANBAN_CARD_RENAME}
                hintKey={EHintKey.KANBAN_CARD_RENAME}
                show
                isHideOnHintClick
                onShow={() => setShowHint(true)}
                isHidable={false}
                arrow={'down'}
                direction={'up'}
                value={CARD_TITLE_EDIT_HINT}
                selector={`.${classUnique} .${CARD_CLASS}__title-inner`}
                isPortal
                portalSelector={`#${CARD_ACTIONS_PORTAL}-${listId}`}
            />
        }
    </>
};
